export default {
  title: "Confirm removal",
  body_description:
    "Are you sure you want to remove this <b class='text-info'>Photo</b> from the <b class='text-info text-capitalize'>{entity}</b>?",
  body_warning: "This is irreversible!",
}
